import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const SHOPIFY_STORE_URL = process.env.REACT_APP_SHOPIFY_STORE_URL || "https://jpizue-ra.myshopify.com";

export const formatPrice = (cents) =>
  `$${((cents || 0) / 100).toFixed(2)}`;

export const applyDiscount = (cents, discount) =>
  Math.max((cents || 0) - (discount || 0), 0);

// FastAPI 422 returns detail as an array of {msg} objects; coerce any shape to a string
// so React never tries to render an object (which crashes).
export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
